// A refused charge names it `payment_method_is_detached`, a payment that failed later carries `method_detached`.
export function getPaymentFailureMessage(error?: string | null): string {
  return error === "payment_method_is_detached" || error === "method_detached"
    ? "Сохранённый способ оплаты больше недоступен. Попробуйте оплатить другим способом."
    : "Попробуйте ещё раз или выберите другой способ оплаты."
}
